<div class="container">
  <div class="row mt-2">
    <div class="col-md-12 ps-0">
      <hr class=rule-left />
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-6">
    <h2 class="content-card-title">{{optionsAndAccessoriesFormTranslations.textAddOption}}</h2>
    <div class="row mt-2">
      <div class="col-md-9">
        <div class="form-group">
          <label for="availableOptions">{{optionsAndAccessoriesFormTranslations.labelAvailableOptions}}</label>
          <button id="availableOptions" class="custom-select select-wrapper" #toggleDropdownButton placement="bottom" (click)="toggleDropdown()" type="button">
            <span>{{installedOptions.length}} {{optionsAndAccessoriesFormTranslations.textInstalledOptions}}</span>
          </button>
          @if (isOpen) {
            <div class="options-and-accessories-popover p-3" #optionsAndAccessoriesPopover>
              <div class="form-group pt-2">
                <label>{{optionsAndAccessoriesFormTranslations.labelSearch}}
                  <input type="text" class="form-control" (input)="search($event)" />
                </label>
              </div>
              @for (group of optionsGroups; track group) {
                <div class="form-group">
                  <label>{{getSubGroupDisplayName(group.subGroupName)}}</label>
                  @for (option of group.options; track option) {
                    <div
                      class="custom-control custom-checkbox advanced_search_class-checkbox mt-2 mb-3 ng-star-inserted">
                      <input (click)="onInstalledOptionChanged(option)" type="checkbox"
                        class="custom-control-input" [checked]="option.installed"
                        id="{{option.optionCode}}">
                      <label class="custom-control-label" for="{{option.optionCode}}">
                        {{option.userFriendlyDescription}}
                      </label>
                    </div>
                  }
                </div>
              }
              <button (click)="this.setInstalledOptions()" class="btn btn-outline-primary btn-block" type="button" data-track-name="Update Installed Options">
                <span>{{optionsAndAccessoriesFormTranslations.textUpdateInstalledOptions}}</span>
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-6">
    <h2 class="content-card-title">{{optionsAndAccessoriesFormTranslations.textManageInstalledOptions}}</h2>
    <div class="content-card-subtitle">
      {{optionsAndAccessoriesFormTranslations.textIdentifyOption}}
    </div>
    <div class="tire-table-container ng-star-inserted">
      @if (installedOptions.length) {
        <table class="table table--managed-installed-options">
          <caption class="visually-hidden"> {{optionsAndAccessoriesFormTranslations.textManageInstalledOptions}} </caption>
          <thead>
            <th scope="col"></th>
            <th scope="col">
              <div class="form-group mb-0 align-center"><label>{{optionsAndAccessoriesFormTranslations.labelAftermarket}}</label></div>
            </th>
            <th scope="col">
              <div class="form-group mb-0 align-center"><label>{{optionsAndAccessoriesFormTranslations.labelRemove}}</label></div>
            </th>
          </thead>
          <tbody>
            @for (option of installedOptions; track option) {
              <tr class="ng-star-inserted">
                <td>{{option.userFriendlyDescription}}</td>
                <td>
                  @if (option.allowAfterMarket === true) {
                    <div class="flex-jc-center">
                      <div class="custom-control custom-checkbox advanced_search_class-checkbox ng-star-inserted">
                        <input type="checkbox" class="custom-control-input"
                          id="aftermarket-{{option.userFriendlyDescription}}"
                          [(ngModel)]="option.afterMarket" [checked]="option.afterMarket"
                          (click)="this.setInstalledOptions()">
                        <label class="custom-control-label" for="aftermarket-{{option.userFriendlyDescription}}"></label>
                      </div>
                    </div>
                  }
                </td>
                <td>
                  <div class="flex-jc-center">
                    <button class="remove-installed-option" (click)="onRemoveInstalledOption(option)" id="remove-{{option.optionCode}}" [attr.aria-label]="optionsAndAccessoriesFormTranslations.ariaLabelremove">
                      <i aria-hidden="true" class="ms-auto allycon-glyph-close text-primary"></i>
                    </button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
    </div>
  </div>
</div>
